module.exports = "<p>\r\n  gdax-http works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// c:/WebProjects/angularcoin/src/app/component/gdax-http/gdax-http.component.html
// module id = ../../../../../src/app/component/gdax-http/gdax-http.component.html
// module chunks = main